import React, { useEffect, useRef, useState } from "react";
import CommonLayout from "../../commoncomponents/layout/CommonLayout";
import OrganizationInfo from "./OrganizationInfo";
import { Backdrop, CircularProgress, Grid, Typography } from "@mui/material";
import classes from "./OrganizationInfo.module.css";
import { useNavigate, useLocation, useNavigationType } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  mobileNoRegex,
  phoneNoRegex,
} from "../../commoncomponents/input/Regex";
import {
  getRequest,
  postAxios,
  singoutHandler,
} from "../../../api/AxiosAPICall";
import ButtonComponent from "../../commoncomponents/buttons/ButtonComponent";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../commoncomponents/alert/SnackbarAction";
import { setOrganizationData } from "../RegistraionAction";
import globalClasses from "../../commoncomponents/css/Global.module.css";

const OrganizationMain = (props: any) => {
  let history = useNavigate();
  const location = useLocation();
  const [mode, setMode] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [headerButton, setHeaderButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isEstablishmentPresent, setIsEstablishmentPresent] = useState(false);

  const navType = useNavigationType();

  let jwtToken: any;
  const isMounted = useRef<any>(false);

  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      if (navType === "POP") {
        history("/unauthenticatedUser");
      }
    };
  }, [navType, history]);

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);

  const alertUser = (e: any) => {
    e.preventDefault();
    e.returnValue = "";
  };

  useEffect(() => {
    isMounted.current = true;
    if (props.mode !== undefined && props.mode !== null && props.mode !== "") {
      setMode(props.mode);
      setHeaderButton(true);
    } else {
      setMode("");
      setHeaderButton(false);
    }
    if (
      location?.state?.mode !== undefined &&
      location?.state?.mode !== null &&
      location?.state?.mode !== "" &&
      location?.state?.mode === "ERROR"
    ) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Something went wrong!",
          "top",
          "center"
        )
      );
    }
    return () => {
      isMounted.current = false;
      setMode("");
      setHeaderButton(false);
    };
    // eslint-disable-next-line
  }, [location, props.mode]);

  const CheckDuplicateEstablishment = async (value: any) => {
    await getRequest("checkDuplicateEstablishment", {
      params: {
        establishmentName: value,
      },
    }).then((response) => {
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setIsEstablishmentPresent(response?.data);
      }
    });
  };

  const formik = useFormik({
    initialValues: {
      organizationId: "",
      estType: "private",
      organizationName: "",
      identifier: "",
      country: "",
      searchDistrict: "",
      numberRoad: "",
      district: "",
      town: "",
      county: "",
      phoneNo: "",
      code: "",
      mobile: "",
      emailId: "",
      verificationCode: "",
    },
    validationSchema: Yup.object({
      organizationId: Yup.string().default(""),
      organizationName: Yup.string().required("Organization Name Required"),

      emailId: Yup.string()
        .email("Please enter valid email.")
        .required("Please enter valid email."),
      numberRoad: Yup.string().required("Please enter  Number & Road."),
      district: Yup.string().required("Please enter  district."),
      town: Yup.string().required("Please enter  town."),
      county: Yup.string().required("Please enter  county."),
      country: Yup.string().required("Please select country"),
      phoneNo: Yup.string()
        .matches(phoneNoRegex, "Please enter valid phone number")
        .required("Please enter phone number"),
      mobile: Yup.string().matches(
        mobileNoRegex,
        "Please enter valid mobile number"
      ),

      verificationCode: Yup.string().max(
        6,
        "Verification Code must be in 6 digit"
      ),
    }),
    onSubmit: async () => {
      setIsLoading(true);
      if (mode !== "edit") {
        if (isEstablishmentPresent) {
          window.scrollTo(0, 0);
          setIsLoading(false);
        } else {
          dispatch(setOrganizationData(formik.values));
          history("/service");
          setIsLoading(false);
        }
      } else {
        const response = await postAxios(
          "establishment",
          {
            estId: formik.values.organizationId,
            estName: formik.values.organizationName,
            estCodePreference: formik.values.identifier
              ? formik.values.identifier
              : null,
            estPatientwebAccess: "1",
            estType: formik?.values?.estType,
            addressJson: {
              addAddress1: formik.values.numberRoad,
              addAddress2: formik.values.district
                ? formik.values.district
                : null,
              addAddress3: formik.values.town ? formik.values.town : null,
              addAddress4: formik.values.county ? formik.values.county : null,
              addAddress6: formik.values.country ? formik.values.country : null,
              addPhone: formik.values.phoneNo ? formik.values.phoneNo : null,
              addMobile: formik.values.mobile ? formik.values.mobile : null,
              addEmail: formik.values.emailId ? formik.values.emailId : null,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );

        if (response.toString() === "ERROR") {
          setIsLoading(false);
          dispatch(
            setSnackbar(
              true,
              undefined,
              "warning",
              "Cellmaflex has encounter an issue. Please contact administrator.",
              "top",
              "center"
            )
          );
        } else if (response.toString() !== "" && typeof response !== "object") {
          setIsLoading(false);
          dispatch(
            setSnackbar(
              true,
              undefined,
              "warning",
              response.toString(),
              "top",
              "center"
            )
          );
          if (mode === "edit") {
            singoutHandler(jwtToken);
            localStorage.removeItem("token");
            history("/signin");
          }
        }
        if (
          response.data.establishmentAddressUpdate === "true" &&
          response.data.establishmentUpdated === "true"
        ) {
          setIsLoading(false);
          dispatch(
            setSnackbar(
              true,
              4000,
              "success",
              "Establishment details and Address has been saved successfully!",
              "top",
              "center"
            )
          );
        }
      }
    },
  });

  const buttonDisplay = () => {
    setIsVisible(true);
    dispatch(
      setSnackbar(
        true,
        4000,
        "success",
        "Email verified successfully",
        "top",
        "left"
      )
    );
  };
  return (
    <CommonLayout
      showHeaderNavigation={headerButton}
      isLogedIn={headerButton === false ? false : true}
    >
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          {mode !== "edit" && (
            <>
              <Typography variant="h1" className={globalClasses.pageTitle}>
                Register your Organization
              </Typography>
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "10px",
                  color: "#474747",
                  fontSize: "14px",
                }}
              >
                Step 1 to step 4 is mandatory in order to complete registration
              </Typography>
            </>
          )}
        </Grid>
      </Grid>
      <OrganizationInfo
        mode={mode !== undefined ? mode : ""}
        buttonDisplay={buttonDisplay}
        formik={formik}
        checkDuplicate={CheckDuplicateEstablishment}
        isEstablishmentPresent={isEstablishmentPresent}
      />
      <Grid item xs={12} md={12} className={classes.nextbuttongrid}>
        <form>
          {mode !== "edit" ? (
            <ButtonComponent
              variant="contained"
              size="small"
              type="submit"
              buttonclass={classes.saveButton}
              onClick={(event: any) => {
                formik.handleSubmit(event);
                dispatch(setSnackbar(false, 0, "success", "", "top", "left"));
              }}
              isvisible={(!isVisible).toString()}
              label="Next"
            />
          ) : (
            mode === "edit" && (
              <ButtonComponent
                variant="contained"
                size="small"
                type="submit"
                buttonclass={classes.saveButton}
                onClick={(event: any) => {
                  formik.handleSubmit(event);
                }}
                label="Save"
              />
            )
          )}
        </form>
      </Grid>

      {mode === "edit" && isLoading && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 1500,
            display: "flex",
            flexDirection: "column",
          }}
          open
        >
          <Typography fontWeight="600" fontSize="20px">
            Updating Organization Information...!
          </Typography>
          <CircularProgress color="primary" sx={{ margin: "20px" }} />
        </Backdrop>
      )}
      {mode !== "edit" && isLoading && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 1500,
            display: "flex",
            flexDirection: "column",
          }}
          open
        >
          <Typography fontWeight="600" fontSize="20px">
            Adding Organization Information...!
          </Typography>
          <CircularProgress color="primary" sx={{ margin: "20px" }} />
        </Backdrop>
      )}
    </CommonLayout>
  );
};

export default OrganizationMain;
